// Tracking-specific ExternalLinksList preset. Passes label="Evidence Links"
// so tracking forms read naturally; keeps a single import site for tracking
// callers. No duplicated label (previous version wrapped + added its own
// label, producing a double "Evidence Links" / "External Links" stack).

import ExternalLinksList from "../../ExternalLinksList";
import type { EvidenceLink } from "../../../../types";

interface EvidenceLinksFieldProps {
  value: EvidenceLink[];
  onChange: (links: EvidenceLink[]) => void;
  disabled?: boolean;
  /** Pre-fills the first row's label (e.g. "CoC"). Passthrough to
   *  ExternalLinksList. */
  firstLinkLabel?: string;
}

export default function EvidenceLinksField({
  value,
  onChange,
  disabled,
  firstLinkLabel,
}: EvidenceLinksFieldProps) {
  return (
    <div data-testid="evidence-links-field">
      <ExternalLinksList
        value={value}
        onChange={onChange}
        disabled={disabled}
        label="Evidence Links"
        firstLinkLabel={firstLinkLabel}
      />
    </div>
  );
}
